/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CompliancePolicyDataCleanUpResponse {
    getFixupPrototypeFunction() { return CompliancePolicyDataCleanUpResponse.fixupPrototype; }

    static newInstance(model: Partial<CompliancePolicyDataCleanUpResponse>): CompliancePolicyDataCleanUpResponse {
        let obj = Object.assign(new CompliancePolicyDataCleanUpResponse(), model);
        CompliancePolicyDataCleanUpResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CompliancePolicyDataCleanUpResponse>): CompliancePolicyDataCleanUpResponse {
        if (!model) return null;
        return CompliancePolicyDataCleanUpResponse.newInstance(<CompliancePolicyDataCleanUpResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CompliancePolicyDataCleanUpResponse) {
        if (!obj) return;

        models.CompliancePolicyDataCleanUpResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CompliancePolicyDataCleanUpResponse): boolean {
        Object.setPrototypeOf(obj, CompliancePolicyDataCleanUpResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Compliance Policy uris
     */
    policy_uris: Array<string>;

}
